import React from 'react';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
} from '@material-ui/core';
import { useLang } from '../../util/lang';
import { getWebAbsPath } from '../../util/path';
import './NewFeaturePopup.css';

const NotificationDialog = ({
    title,
    content,
    showPopup,
    setShowPopup,
    notificationCheckbox,
    setNotificationCheckbox,
    onConfirm,
    confirmButtonText,
    onClose,
    moreDetailLink,
    moreDetailText,
}) => {
    const get = useLang();

    return (
        <Dialog open={showPopup} aria-labelledby="confirm-dialog">
            <DialogTitle id="confirm-dialog" className="dialog-title">
                <strong>{get(title)}</strong>
            </DialogTitle>
            <DialogContent className="dialog-content">
                {typeof content === 'object' && Array.isArray(content)
                    ? content.map((v) => (
                          <>
                              <Grid container className="dialog-content-container">
                                  <Grid item xs={2}>
                                      <img src={getWebAbsPath(v.icon)} className="dialog-content-icon" />
                                  </Grid>
                                  <Grid item xs={10} style={{ paddingLeft: '15px' }}>
                                      <span className="dialog-content-title">{v.title ? get(v.title) : ''}</span>
                                      <div>{v.content ? get(v.content) : ''}</div>
                                  </Grid>
                              </Grid>
                          </>
                      ))
                    : content}
            </DialogContent>
            <DialogActions className="dialog-actions">
                <div key="dialog_bottom">
                    <a href={get(moreDetailLink)} target="_blank" className="dialog-actions-link">
                        {get(moreDetailText)}
                    </a>
                    <br />
                    <div key="dialog_form" className="dialog-actions-form">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={notificationCheckbox}
                                    onChange={(event) => setNotificationCheckbox(event.target.checked)}
                                    className="dialog-actions-form-checkbox"
                                />
                            }
                            label={get('@NotificationDialog.do_not_show_again')}
                        />
                        <Button
                            variant="contained"
                            onClick={async () => {
                                setShowPopup(false);
                                if (onConfirm) await onConfirm();
                                if (onClose) await onClose();
                            }}
                            className="dialog-actions-form-button"
                        >
                            {get(confirmButtonText ?? ':const.confirm')}
                        </Button>
                    </div>
                </div>
            </DialogActions>
        </Dialog>
    );
};
export default NotificationDialog;
